<template>
  <ModalDialog
    modal-style="width: 725px;"
    @closeDialog="handleCloseDialog"
  >
    <div class="purpose">
      Hash for <a
        target="_blank"
        :href="pkg.URL"
      >
        {{ pkg.filename }}
      </a>
    </div>
    <div class="tableContainer">
      <table class="contentListing">
        <thead>
          <tr>
            <th data-automation="algorithm-header">
              Algorithm
            </th>
            <th data-automation="hash-digest-header">
              Hash Digest
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr>
            <td data-automation="file-algorithm">
              SHA256
            </td>
            <td
              :id="'sha256-' + pkg.digests.sha256"
              data-automation="file-hash-digest"
            >
              {{ pkg.digests.sha256 }}
            </td>
            <td>
              <button
                class="copyButton"
                :data-clipboard-target="'#sha256-' + pkg.digests.sha256"
                :data-automation="'file-hash-copy-button-' + pkg.digests.sha256"
              >
                Copy
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ModalDialog>
</template>

<script>

import ModalDialog from '../dialogs/ModalDialog'

export default {
  name: 'FileHashModal',
  components: {
    ModalDialog,
  },
  props: {
    pkg: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleCloseDialog: function () {
      this.$emit('closeDialog', null)
    },
  },
}

</script>
